var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./VueBootstrapTypeaheadListItem.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ef2d9642\"}!../../../vue-loader/lib/selector?type=template&index=0!./VueBootstrapTypeaheadListItem.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bootstrap-typeahead/src/components/VueBootstrapTypeaheadListItem.vue
// module id = 1099
// module chunks = 5